import { Typography, Paper } from '@mui/material';
import ShareItems from '.';

export default function Followers() {
  return (
    <Paper
      elevation={1}
      sx={{
        height: '100%',
        padding: '48px 32px',
        borderRadius: '12px',
        width: '100%',
        boxShadow: 'none',
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          mb: 2,
          fontWeight: '700',
          fontSize: '28px',
          lineHeight: '40px',
          color: '#232B35',
        }}
      >
        Turn contacts & followers into advisors
      </Typography>
      <Typography
        sx={{
          mb: 2,
          fontWeight: '400',
          fontSize: '20px',
          lineHeight: '40px',
          color: '#232B35',
        }}
      >
        The bigger your board, the more ideas and advocates for you. We
        recommend sharing your advisory board wherever you have the largest
        following.
      </Typography>
      <Typography
        sx={{
          mb: 2,
          fontWeight: '700',
          fontSize: '20px',
          lineHeight: '40px',
          color: '#232B35',
        }}
      >
        Click below to see how easy it is:
      </Typography>
      <ShareItems />
    </Paper>
  );
}
